


export class CostCenterAniel {
  "controllingArea";
  "companyCode";
  "costCenter";
  "validToDate";
  "validFromDate";
  "personResponsible";
  "currencyKey";
  "profitCenter";
  "createdOn";
  "enteredBy";
  "lockIndicatorForActualSecondaryCosts";
  "lockIndicatorForActualRevenuePostings";
  "lockIndicatorForCommitmentUpdate";
  "lockIndicatorForPlanSecondaryCosts";
  "lockIndicatorForPlanningRevenues";
  "indicatorForAllowedAllocationMethods";
  "indicatorForRecordingConsumptionQuantities";
  "department";
  "subsequentCostCenter";
  "generalName";
  "description";
  "dtImportacao";
  "id";
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `CostCenterAniel`.
   */
  static getModelName() {
    return "CostCenterAniel";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of CostCenterAniel for dynamic purposes.
  **/
  static factory(data) {
    return new CostCenterAniel(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'CostCenterAniel',
      plural: 'CostCenterAniels',
      path: 'CostCenterAniels',
      properties: {
        "controllingArea": {
          name: 'controllingArea',
          type: 'string'
        },
        "companyCode": {
          name: 'companyCode',
          type: 'string'
        },
        "costCenter": {
          name: 'costCenter',
          type: 'string'
        },
        "validToDate": {
          name: 'validToDate',
          type: 'Date'
        },
        "validFromDate": {
          name: 'validFromDate',
          type: 'Date'
        },
        "personResponsible": {
          name: 'personResponsible',
          type: 'string'
        },
        "currencyKey": {
          name: 'currencyKey',
          type: 'string'
        },
        "profitCenter": {
          name: 'profitCenter',
          type: 'string'
        },
        "createdOn": {
          name: 'createdOn',
          type: 'Date'
        },
        "enteredBy": {
          name: 'enteredBy',
          type: 'string'
        },
        "lockIndicatorForActualSecondaryCosts": {
          name: 'lockIndicatorForActualSecondaryCosts',
          type: 'string'
        },
        "lockIndicatorForActualRevenuePostings": {
          name: 'lockIndicatorForActualRevenuePostings',
          type: 'string'
        },
        "lockIndicatorForCommitmentUpdate": {
          name: 'lockIndicatorForCommitmentUpdate',
          type: 'string'
        },
        "lockIndicatorForPlanSecondaryCosts": {
          name: 'lockIndicatorForPlanSecondaryCosts',
          type: 'string'
        },
        "lockIndicatorForPlanningRevenues": {
          name: 'lockIndicatorForPlanningRevenues',
          type: 'string'
        },
        "indicatorForAllowedAllocationMethods": {
          name: 'indicatorForAllowedAllocationMethods',
          type: 'string'
        },
        "indicatorForRecordingConsumptionQuantities": {
          name: 'indicatorForRecordingConsumptionQuantities',
          type: 'string'
        },
        "department": {
          name: 'department',
          type: 'string'
        },
        "subsequentCostCenter": {
          name: 'subsequentCostCenter',
          type: 'string'
        },
        "generalName": {
          name: 'generalName',
          type: 'string'
        },
        "description": {
          name: 'description',
          type: 'string'
        },
        "dtImportacao": {
          name: 'dtImportacao',
          type: 'Date'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/CostCenterAniel.js